'use client';

import { useEffect, useState } from 'react';
import Modal from '../Modal';
import NewsForm from './NewsForm';
import Email from '../svg/Email';

export default function NewsButton() {
  const [mounted, setMounted] = useState(false);
  const [show, setShow] = useState(false);
  const toggleShow = () => setShow(!show);

  useEffect(() => {
    setMounted(true);
  },[])

  if (!mounted) return null;

  return (
    <>
    {show ? (
      <Modal close={toggleShow} className='max-w-[600px]'>
        <NewsForm close={toggleShow}/>
      </Modal>
    ) : null}
      <div onClick={() => toggleShow()} className='bg-primary rounded-[8px] flex items-center justify-center gap-[12px] mx-auto px-[24px] cursor-pointer h-[42px] select-none'><Email/><span className='text-white h6 whitespace-nowrap overflow-x-hidden'>اشترك معنا</span></div>
    </>
  )
}